<template>
  <div>
    <base-collapse
      v-if="content.children"
      v-model="isExpanded"
      class-toggle="w-full"
      @click.stop="handleCollapse"
    >
      <template #toggle="{ expanded }">
        <span class="flex items-center px-4 between" :class="brandClasses.title">
          <span :class="presets?.[content.menuStyle!]">
            <span v-if="$feature.showTitleHtml" v-html="content.titleHtml" />
            <span v-else>{{ content.title }}</span>
          </span>
          <vf-icon v-if="content.children" :dir="expanded ? 'up' : 'down'" name="chevron" size="lg" />
        </span>
      </template>
      <ul v-if="content.children?.length" class="text-sm ">
        <cms-mega-menu-l3-mobile
          v-if="$feature.showShopAllL3sOnMobile && !content.hideShopAll?.sm"
          :content="{
            id: `${content.id}-shop-all`,
            type: 'VfCanvasMegaMenuL3',
            name: content.name,
            title: `${$t.megaMenuShopAll} ${content.title}`,
            titleHtml: `${$t.megaMenuShopAll} ${content.titleHtml}`,
            target: { id: `${content.id}-target`, url: content.target?.url, type: 'CMExternalChannel' },
          }"
          @click="$emit('click')"
        />
        <li v-for="menuItem in content.children" :key="menuItem.id">
          <cms-section :section="{ name: menuItem.id, items: [{ ...menuItem, isFullWidth: true }] }" />
        </li>
      </ul>
    </base-collapse>
    <base-link
      v-else
      :class="[presets?.[content.menuStyle!], brandClasses.link]"
      :target="content.target?.targetAttribute"
      :to="content.target?.url"
      @click.stop="$emit('click')"
    >
      <span v-if="$feature.showTitleHtml" v-html="content.titleHtml" />
      <span v-else>{{ content.title }}</span>
    </base-link>
  </div>
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'

defineProps<{
  content: MenuItem
}>()

const emit = defineEmits<{
  click: []
  close: []
  expand: []
}>()

const { brandClasses, presets } = useAppConfig().components.cms.megaMenuL2Mobile

const isExpanded = ref(false)

const handleCollapse = () => isExpanded.value ? emit('expand') : emit('close')
</script>
